import React from 'react';
import { classNames } from '@/shared/lib/classnames/classnames';
import { Button } from '@/shared/ui/button';
import btnIcons from '@/shared/assets/sprites/btns.sprite.svg';
import type { ShowPhoneButtonProps } from '../model/types';
const ShowPhoneButton = React.forwardRef<HTMLButtonElement, ShowPhoneButtonProps>((props, ref) => {
  const {
    hasOnline,
    isLoading,
    onClick,
    text,
    btnVariants,
    isFull = false,
    isIcon = false
  } = props;
  const getVariant = () => {
    if (isIcon) return 'secondary';
    return hasOnline ? 'outlined' : 'default';
  };
  const getSize = () => {
    if (isIcon) return 'icon';
    return btnVariants?.size ?? 'sm';
  };
  return <Button ref={ref} size={getSize()} variant={getVariant()} textWeight={btnVariants?.textWeight ?? 'bold'} className={classNames('touch-pan-y', {
    'mt-2': hasOnline && !isIcon,
    'w-full': isFull
  })} onClick={onClick} loading={isLoading}>
      {isIcon ? <svg className="size-6 stroke-primary stroke-1.5">
          <use xlinkHref={`${btnIcons}#phone`}></use>
        </svg> : text}
    </Button>;
});
ShowPhoneButton.displayName = 'ShowPhoneButton';
export { ShowPhoneButton };